import { createRouter, createWebHistory } from 'vue-router'
import store from '@/configure/store'

// import adminModule from './adminModule'


const routes = [
  {
    path: '/',
    name: '/index',
    // component: () => import('@/pages/commonModule/indexAdminFrame/index'),
    // children: [].concat(moduleRoutes)
    redirect:'/workbench'
  },
  {
    path:'/workbench',
    name:'workbench',
    component: () => import('@/pages/commonModule/indexAdminWorkbench/index')

  },
  {
    path: '/indexAdminLogin',
    component: () => import('@/pages/commonModule/indexAdminLogin/index')
  },
  {
    path: '/:pathMatch(.*)',
    name: '/index404',
    component: () => import('@/pages/commonModule/index404/index')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = store.state.systemMetaBaseData.systemName
  if (to.path !== '/indexAdminLogin') {
    const adminToken = store.state.userData.adminToken
    if (adminToken === '' || adminToken === undefined) {
      next('/indexAdminLogin')
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  document.title = store.state.systemMetaBaseData.systemName
  next()
})

export default router
